<div class="unauthorized-container">
  <div class="unauthorized-content">
    <div class="icon">
      <i class="pi pi-ban" style="font-size: 4rem; color: #e74c3c;"></i>
    </div>
    
    <h1>Access Denied</h1>
    <p class="message">
      You don't have permission to access this resource.
    </p>
    <p class="sub-message">
      Please contact your administrator if you believe this is an error.
    </p>
    
    <div class="actions">
      <p-button 
        label="Go Back" 
        icon="pi pi-arrow-left" 
        (onClick)="goBack()"
        severity="secondary">
      </p-button>
      
      <p-button 
        label="Login Again" 
        icon="pi pi-sign-in" 
        (onClick)="goToLogin()"
        severity="primary">
      </p-button>
    </div>
  </div>
</div>
